// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, Typography } from '@mui/material';

interface Props {
  label: string;
  date: string | null;
}

/**
 * Displays a label and date value in a row format, typically used in tooltips.
 * Shows "Not set" when the date is null.
 */
export function DateInfoRow(props: Props) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      width="100%"
      flexWrap="wrap"
      gap={0.5}
    >
      <Typography variant="subtitle2">{props.label}</Typography>
      {props.date ? (
        <Typography variant="body2">{props.date}</Typography>
      ) : (
        <Typography variant="body2" color="background.contrastText">
          Not set
        </Typography>
      )}
    </Stack>
  );
}
